import { TooltipRenderProps } from "react-joyride";
import ButtonComponent from "../common/ButtonComponent";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { previewSearchWarrantDocument, resetDocumentViewData } from "../../redux/slice/documentViewerSlice";
import FormViewer from "./FormView";
import { useTemplateReducer } from "../../redux/slice/templateSlice";
import { useAppDispatch } from "../../hooks/hooks";
import { RiArrowLeftLine, RiArrowRightLine } from "react-icons/ri";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DocumentViewer from "../common/DocumentViewer";


type ViewType = 'Form View' | 'Document View';

const StepContent: React.FC<TooltipRenderProps> = (props) => {
  const { step, primaryProps } = props;
  const { title, content } = step;

  const dispatch = useAppDispatch();
  const templateReducer = useTemplateReducer();
  const [view, setView] = useState<ViewType>('Form View');
  const [index, setIndex] = useState(0);

  const formList = useMemo(() => {
    return ["Complaint/Search Warrant", "Proof of Service", "Inventory", "Order of Custody"];
  }, [])

  useEffect(() => {
    dispatch(resetDocumentViewData())
    let fieldName = content as string;
    let warrantFormObj = {
      txtOffense1Header: templateReducer.offenseInfoHeader,
      txtOffense1: templateReducer.offenseInfo,
      txtSeized1Header: templateReducer.seizedInfoHeader,
      txtSeized1: templateReducer.seizedInfo,
      txtPoliceOfficerInfoHeader: templateReducer.policeOfficerInfoHeader,
      txtPoliceOfficerInfo: templateReducer.policeOfficerInfo,
      txtPersonInfoHeader: templateReducer.personOfHeader,
      txtPersonInfo: templateReducer.personOf,
      personOfHeaderPrefix: templateReducer.personOfHeaderPrefix,
      personOfHeaderSuffix: templateReducer.personOfHeaderSuffix,
      offenseInfoHeaderSuffix: templateReducer.offenseInfoHeaderSuffix,
      policeOfficerInfoHeaderSuffix: templateReducer.policeOfficerInfoHeaderSuffix,
      impoundLanguage: templateReducer.impoundLanguage,
      complaintHeaderPrefix: templateReducer.complaintHeaderPrefix,
      warrantField1Prefix: templateReducer.warrantField1Prefix,
      warrantField2Prefix: templateReducer.warrantField2Prefix,
      warrantHeader3Prefix: templateReducer.warrantHeader3Prefix,
      warrantOrderCommand: templateReducer.warrantOrderCommand,
      complaintTitle: templateReducer.complaintTitle,
      swTitle: templateReducer.swTitle,
      impoundComplaintLanguage: templateReducer.impoundComplaintLanguage,
      personPremisesExecutedText: templateReducer.pOSPrsnPremisesText,
      personPremisesAndOrText: templateReducer.pOSPrsnPremisesPrint,
      txtPersonPremiseslbl: templateReducer.invntryPrsnPrmsTxt,
      lblInventoryPrintText: templateReducer.invntryPrsnPrmsPrint,
      txtPersonPremises: templateReducer.personOf,
      warrantSeizedInfo: templateReducer.seizedInfo,
      //KHL PR-11666 08/27/2025 - START
      complaintDocHeader: templateReducer.complaintDocHeader,
      swDocHeader: templateReducer.swDocHeader,
      //KHL PR-11666 08/27/2025 - END
    };
    if (typeof formList[index] !== 'undefined' && formList[index] === "Inventory") {
      warrantFormObj = {
        ...warrantFormObj,
        txtSeized1: templateReducer.overrideInventorySeizedLanguage ? templateReducer.overrideInventorySeizedLanguage : templateReducer.seizedInfo,
      }
      if (fieldName === "seizedInfo" && templateReducer.overrideInventorySeizedLanguage)
        fieldName = "OTHER";
      else if (fieldName === "overrideInventorySeizedLanguage" && templateReducer.overrideInventorySeizedLanguage)
        fieldName = "seizedInfo";
    }
    dispatch(previewSearchWarrantDocument({
      formObject: warrantFormObj,
      formType: formList[index]?.replace("/",""),
      templateType: "ComplaintSearch Warrant",
      fieldName: fieldName,
    }))
  }, [index, content])

  const viewChangeHandler = useCallback((view: ViewType) => {
    if (view && view === 'Form View')
      setView('Document View')
    else if (view && view === 'Document View')
      setView('Form View')
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', overflowX: 'hidden' }} className="react-joyride__tooltip">
      <div className="step-content-popup-header">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <b><span style={{ fontSize: '18px' }}>{(formList[index] + " " + view).toUpperCase()} : </span>{title}</b>
          </div>

          <div>
            <ButtonComponent className="right-button" size="sm" onClick={() => viewChangeHandler(view)}>
              {view === 'Document View' ? 'Form View' : 'Document View'}
            </ButtonComponent>
          </div>
        </div>
      </div>
      <div style={{ overflowY: 'auto', flexGrow: 1, padding: '8px',  overflowX: 'hidden' }}>
        {formList.length !== index+1 && typeof formList[index+1] !== 'undefined' &&
        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{`${formList[index+1]} ${view}`}</Tooltip>} placement={'auto'}>
                                <button
                                    onClick={() => setIndex(prev => prev+1)}
                                    style={{
                                        top: '300px',
                                        left: '920px',
                                    }}
                                    className="form-navigate-button"
                                >
                                    <RiArrowRightLine fontSize={'35px'}/>
                                </button>
                                </OverlayTrigger>
        }
        {view && view === 'Form View' ? <FormViewer elementName={content as string} formType={formList[index]} templateType={"ComplaintSearch Warrant"}/> : <DocumentViewer />}
                {index  !== 0 && typeof formList[index-1] !== 'undefined' &&
        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{`${formList[index-1]} ${view}`}</Tooltip>} placement={'auto'}>
                                <button
                                    onClick={() => setIndex(prev => prev-1)}
                                    style={{
                                        top: '300px',
                                        left: '20px',
                                    }}
                                    className="form-navigate-button"
                                >
                                    <RiArrowLeftLine fontSize={'35px'}/>
                                </button>
                                </OverlayTrigger>
      }
      </div>
      <div className="step-content-popup-footer">
        <ButtonComponent {...primaryProps} size="sm" variant="info" style={{ marginLeft: 8 }} onClick={(e) => { primaryProps.onClick(e); dispatch(resetDocumentViewData()) }}>
          {'Close'}
        </ButtonComponent>
      </div>
    </div>
  )
};

export default StepContent;